import React from "react";
import localize from "../../../../core/utils/translation-files";
export default function LoginText() {
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "login-detail-text" },
            React.createElement("span", null, localize(["Login.transformingYourBusiness"])),
            React.createElement("h5", null, localize(["Login.fromReactiveToProactive"])))));
}
